<template>
  <div class="page">
    <el-pagination
      :current-page.sync="page.currentPage"
      :page-size.sync="page.pageSize"
      :layout="layout"
      @size-change="handleSizeChange"
      @current-change="onPageChange"
    />
    <span v-if="showTotalPage" class="total-page">
      /{{ totalPage }}页
    </span>

  </div>
</template>

<script>
export default {
  props: {
    page: {
      type: Object,
      required: true
    },
    layout: {
      type: String,
      default: 'prev, next, jumper'
    },
    showTotalPage: {
      type: Boolean,
      default: true
    },
    isShowSelectedNum: {
      type: Boolean,
      default: true,
    },
    selectedNum: {
      type: Number,
      default: 0
    },
  },
  computed: {
    totalPage() {
      const { total, pageSize } = this.page

      return Math.ceil(total / pageSize) || 1
    }
  },
  methods: {
    onPageChange() {
      this.$emit('page-change')
    },
    handleSizeChange() {
      this.page.currentPage = 1
      this.onPageChange()
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  display: flex;
  ::v-deep .el-pagination__jump {
    font-size: 0!important;
    margin-left: 10px;
  }

  .total-page {
    // width: 34px;
    line-height: 32px;
    font-size: 13px;
    font-family: SFProText-Regular, SFProText;
    font-weight: 400;
    color: #606266;
    // margin-right: 12px;
  }

  .selected-box {
    margin-right: 16px;
    line-height: 32px;
    font-size: 13px;
    font-family: SFProText-Regular, SFProText;
    // font-weight: 400;
    color: #606266;
    margin-top: -1px;

    .selected-box__number {
      color: $B6;
      font-size: 13px;
      font-weight: 600;
    }
  }

  ::v-deep .el-pagination__editor.el-input .el-input__inner {
    height: 32px;
    &:hover {
      border-color: $main-color;
    }
  }

  ::v-deep .btn-prev, ::v-deep .btn-next {
    height: 32px;
    width: 32px;
    min-width: auto;
    border-radius: 2px;
    border: 1px solid #DCDFE6;
    text-align: center;
    padding: 0;

    &:hover {
      border-color: $main-color;
    }

    &:disabled {
      border-color: #DCDFE6;
    }
  }

  ::v-deep .btn-next {
    margin-left: 10px;
  }

  .el-pagination {
    padding: 0;
  }

  .el-pagination ::v-deep {
    span:not([class*=suffix]), .el-pagination__jump {
      height: 32px;
      line-height: 32px;
    }
  }

  ::v-deep .el-input--mini .el-input__inner {
    height: 32px;
    border-radius: 2px!important;
  }

  // 为了让 pager 箭头居中
  ::v-deep .el-select .el-input .el-select__caret {
    position: relative;
    top: 4px;
  }
}
</style>
